// // style
import 'assets/styles/style.scss';
import 'react-perfect-scrollbar/dist/css/styles.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

// Redux
import configureStore from './store/configureStore';
import { PersistGate } from 'redux-persist/integration/react';

// Cookie
import { CookiesProvider } from 'react-cookie';

// 시간
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { ko } from 'date-fns/locale';

// 라우트
import App from './App';

const { store, persistor } = configureStore()

const renderApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <CookiesProvider defaultSetOptions={{ path: '/' }}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ko}>
              <App />
            </LocalizationProvider>
          </PersistGate>
        </Provider>
      </CookiesProvider>
    </React.StrictMode>
  )
}

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept(App, renderApp)
}

renderApp()

export {store, persistor}